import React from 'react'
import { Col, Row } from 'antd'
import ThemeCard from '../security/ThemeCard'
import { useDocumentTitle } from '../../../../hooks/useDocumentTitle'

const PreferencesSection = () => {
    useDocumentTitle('Preferences')

    return (
        <Row gutter={[24, 24]}>
            <Col xs={24} sm={24} md={12} lg={8} xl={8}>
                <ThemeCard />
            </Col>
        </Row>
    )
}

export default PreferencesSection

